import { normalizeMemberBooking } from './upcomingBookingsCache'

const detailPaths = {
  golf: (club, id) => `/api/members-portal/${club}/golf/bookings/${id}`,
  racquet: (club, id) => `/api/members-portal/${club}/racquet/bookings/${id}`,
  spa: (club, id) => `/api/members-portal/${club}/spa/bookings/${id}`,
  fitness: (club, id) => `/api/members-portal/${club}/fitness/bookings/${id}`,
}

const first = (row, ...keys) => keys.map((key) => row?.[key]).find((value) => value !== undefined && value !== null && value !== '')

export function normalizeBookingSuccessDetail(module, payload, bookingId) {
  const row = payload?.data || payload?.booking || payload
  return normalizeMemberBooking({
    ...row,
    bookingId: first(row, 'bookingId', 'booking_id', 'id') || bookingId,
    source: module,
    type: first(row, 'type', 'booking_type') || module,
    title: first(row, 'title', 'course_name', 'court_name', 'service_name', 'class_name', 'name'),
    locationName: first(row, 'locationName', 'location_name', 'course_name', 'court_name', 'room_name', 'venue_name'),
    startAt: first(row, 'startAt', 'start_at', 'tee_time', 'slot_time'),
    timeZone: first(row, 'timeZone', 'time_zone', 'timezone', 'course_time_zone', 'club_time_zone'),
    imageUrl: first(row, 'imageUrl', 'image_url', 'course_image_url', 'facility_image_url', 'photo_url'),
    imageFocusX: first(row, 'imageFocusX', 'image_focus_x', 'course_image_focus_x'),
    imageFocusY: first(row, 'imageFocusY', 'image_focus_y', 'course_image_focus_y'),
    total_cost: first(row, 'total_cost', 'totalCost', 'amount', 'price_total'),
    bookingReference: first(row, 'bookingReference', 'booking_reference', 'reservation_reference') || bookingId,
    participants: first(row, 'participants', 'players', 'attendees'),
    payment_summary: first(row, 'payment_summary', 'paymentSummary'),
  })
}

export async function hydrateBookingSuccess({ module, clubCode, bookingId, memberPortalApiGet }) {
  const resolvePath = detailPaths[module]
  if (!resolvePath || !clubCode || !bookingId) return null
  const response = await memberPortalApiGet(resolvePath(encodeURIComponent(clubCode), encodeURIComponent(bookingId)))
  const json = await response.json().catch(() => null)
  if (!response.ok || json?.ok === false) throw new Error(json?.error || 'booking_detail_unavailable')
  return normalizeBookingSuccessDetail(module, json, bookingId)
}
